import React from 'react';
import { useQuery } from '@apollo/client/react';
import Loading from './LoadingSpinner';
import { gql } from '../__generated__';

interface Props {
  query: any;
  children: (queryProps: any) => React.ReactNode;
  [key: string]: any;
}

const QueryWithLoading = ({ query, children, ...rest }: Props) => {
  if (typeof query === 'string') {
    query = gql(query);
  }
  const queryProps = useQuery<any, any>(query, { errorPolicy: 'all', ...rest });
  const { loading, error, data } = queryProps;

  if (error && !data) {
    return (
      <div>
        <h3>GraphQl error</h3>
        <div>
          <pre>{JSON.stringify(error, null, 2)}</pre>
        </div>
      </div>
    );
  }

  if (loading && !data) {
    return <Loading />;
  }

  return <>{children(queryProps)}</>;
};

export default QueryWithLoading;
